import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import { Router } from "react-router-dom";
import Routes from "./routes";
import history from "./services/history";
import theme from "./theme";

ReactDOM.render(
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <Router history={history}>
      <Routes />
    </Router>
  </ThemeProvider>,
  document.querySelector("#root")
);
